// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2CN4i","requiredAsterisk":"Info_requiredAsterisk__39YJy"};